import React from 'react'
import ReactTable from 'react-table'
import PropTypes from 'prop-types'
import ContainerDimensions from 'react-container-dimensions'
import 'react-table/react-table.css'
import './Table.scss'
import { defaultsDeep } from 'lodash'
import { Icon } from 'antd'
import Spin from './../Spin/Spin'
import Pagination from './pagination/Pagination'

const LoadingComponent = (props) => {
  return props.loading ? <div className='-loading -active'>
    <div className="-loading-inner" style={{ marginTop: '-26px' }}>
      <Spin />
    </div>
  </div> : null
}

const defaultStyles = {
  reactTable: {
    border: 'none',
    lineHeight: 1.3
  },
  thead: {
    boxShadow: 'none',
    borderBottom: '1px solid #ddd',
    backgroundColor: '#f2f2f2',
  },
  theadTh: {
    textAlign: 'left',
    border: 'none',
    padding: '.7rem',
    textTransform: 'uppercase',
    color: '#646464',
    verticalAlign: 'bottom'
  },
  tfoot: {
    boxShadow: 'none',
    borderTop: '1px solid #ddd',
    backgroundColor: '#f2f2f2',
  },
  tfootTd: {
    textAlign: 'left',
    border: 'none',
    padding: '.7rem',
    textTransform: 'uppercase',
    color: '#646464',
    verticalAlign: 'bottom'
  },
  trGroup: {
    minHeight: 52
  },
  td: {
    padding: '.7rem',
    color: '#222',
    verticalAlign: 'top',
    alignSelf: 'baseline'
  },
  noData: {
    top: '72%',
    background: 'none'
  }
}

const getProps = (styles) => ({
  minRows: 1,
  sortable: false,
  resizable: false,
  showPagination: false,
  showPaginationText: true, // custom this will shows 1 of 100 page
  defaultPageSize: 100,
  style: styles.reactTable,
  paginationLeftCmp: null, //custom this will render react element to left side of the pagination
  paginationRightCmp: null, // custom this will render react element to the right side if te pagination
  showTotal: false, //custom
  totalRows: null, //custom
  noDataText: 'No data found',
  firstPageText: <Icon type={'step-backward'} />,
  lastPageText: <Icon type={'step-forward'} />,
  previousText: <Icon type={'left'} />,
  nextText: <Icon type={'right'} />,
  getTableProps: () => ({ style: styles.table }),
  getTheadGroupProps: () => ({ style: styles.theadGroup }),
  getTheadGroupTrProps: () => ({ style: styles.theadGroupTr }),
  getTheadGroupThProps: () => ({ style: styles.theadGroupTh }),
  getTheadProps: () => ({ style: styles.thead }),
  getTheadTrProps: () => ({ style: styles.theadTr }),
  getTheadThProps: () => ({ style: styles.theadTh }),
  getTheadFilterProps: () => ({ style: styles.theadFilter }),
  getTheadFilterTrProps: () => ({ style: styles.theadFilterTr }),
  getTheadFilterThProps: () => ({ style: styles.theadFilterTh }),
  getTbodyProps: () => ({ style: styles.tbody }),
  getTrGroupProps: () => ({ style: styles.trGroup }),
  getTrProps: () => ({ style: styles.tr }),
  getThProps: () => ({ style: styles.theadTh }),
  getTdProps: () => ({ style: styles.td }),
  getTfootProps: () => ({ style: styles.tfoot }),
  getTfootTrProps: () => ({ style: styles.tfootTr }),
  getTfootTdProps: () => ({ style: styles.tfootTd }),
  getPaginationProps: () => ({ style: styles.pagination }),
  getLoadingProps: () => ({ style: styles.loading }),
  getNoDataProps: (props) => ({ style: { ...styles.noData, display: props.loading ? 'none' : undefined } }),
  getResizerProps: () => ({ style: styles.resizer })
})
class Table extends React.Component {
  // constructor(props) {
  //   super(props)
  // }
  render() {
    const { styles, autoScrollbar, ...restProps } = this.props
    const { pageSize, showPagination, data = [] } = restProps
    const _pageSize = showPagination ? pageSize : data.length
    if (autoScrollbar) {
      return <ContainerDimensions>

        {({ height }) => {
          return <ReactTable
            ref={r => this.reactTable = r}
            LoadingComponent={LoadingComponent}
            PaginationComponent={Pagination}
            {...getProps(defaultsDeep(styles, defaultStyles))}
            {...restProps} pageSize={_pageSize} style={{height}}  />
        }}

      </ContainerDimensions>
    }
    return <ReactTable
      ref={r => this.reactTable = r}
      LoadingComponent={LoadingComponent}
      PaginationComponent={Pagination}
      {...getProps(defaultsDeep(styles, defaultStyles))}
      {...restProps} pageSize={_pageSize} />
  }
}

Table.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array
}

Table.ReactTable = ReactTable
export default Table
